<template>
    <div class="pb-5">
      <table-element
        :isShowFilter="true"
        :title="$t('Vehicles.trailers')"
        :fields="fieldsObj"
        :arrOfElement="trailers"
        :sortSpacing="0"
        class="card mx-2 mb-5"
        @updateFilterResults="updateFilterResults"
      >
        <template #header-actions>
        </template>
  
        <template #body-content-desktop="content">
          <tr v-for="(trailer, index) in content.results"
          class="table-element_hover text-center"
          :key="index">
              <td class="nowrap"><p class="table-fix-width">{{trailer.trailerNumber}}</p></td>
              <td>{{trailer.brand}}</td>
              <td class="nowrap"><p class="table-fix-width">{{trailer.model}}</p></td>
              <td>{{trailer.year}}</td>
              <td>{{trailer.vin}}</td>
              <td>{{trailer.plateNumber}}</td>
              <td v-if="!isViewer">
                <input @click.prevent="modifying(trailer); setModalTitle($t('Vehicles.modifyTrailerTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('Vehicles.modify')">
              </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <transition-group name="fade">
            <div class="card my-3 mx-2" v-for="trailer in content.results" :key="trailer['.key']">
              <div class="card-header m-2">
                <h4>{{trailer.trailerNumber}} {{trailer.brand}}</h4>
                <p><i class="fa fa-envelope mr-1" />{{trailer.model}}</p>
              </div>
              <div class="m-2">
                <p><i class="fa fa-phone" /> {{trailer.year}}</p>
                <p><i class="fa fa-users" /> {{trailer.vin}}</p>
                <p><i class="fa fa-lock " /> {{trailer.plateNumber}}</p>
                <div id="action" v-if="!isViewer">
                  <input @click.prevent="modifying(trailer); setModalTitle($t('Vehicles.modifyTrailerTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('Vehicles.modify')">
                </div>
              </div>
            </div>
          </transition-group>
        </template>
      </table-element>
  
      <loading-render v-if="isLoading" />
  
      <!-- Modal -->
      <transition name="fade">
        <modal
          :title="modalTitle"
          v-if="add || modify"
          @close-request="add = false; modify = false; clear()"
          closable
        >
          <div>
            <label class="col-12" for="trailerNumber">{{$t('Vehicles.trailerNumber')}} *</label>
            <regular-input
            id="trailerNumber"
            :value="trailer.trailerNumber"
            @input="trailer.trailerNumber = $event"
            type="text" :placeholder="$t('Vehicles.trailerNumber')" class="col-12 form-group"/>

            <label class="col-12" for="brand">{{$t('Vehicles.brand')}} *</label>
            <regular-input
            id="brand"
            :value="trailer.brand"
            @input="trailer.brand = $event"
            type="text" :placeholder="$t('Vehicles.brand')" class="col-12 form-group"/>

            <label class="col-12" for="model">{{$t('Vehicles.model')}} *</label>
            <regular-input
            id="model"
            :value="trailer.model"
            @input="trailer.model = $event"
            type="text" :placeholder="$t('Vehicles.model')" class="col-12 form-group"/>

            <label class="col-12" for="year">{{$t('Vehicles.year')}} *</label>
            <regular-input
            id="year"
            :value="trailer.year"
            @input="trailer.year = $event"
            type="text" :placeholder="$t('Vehicles.year')" class="col-12 form-group"/>

            <label class="col-12" for="vin">{{$t('Vehicles.vin')}} *</label>
            <regular-input
            id="vin"
            :value="trailer.vin"
            @input="trailer.vin = $event"
            type="text" :placeholder="$t('Vehicles.vin')" class="col-12 form-group"/>

            <label class="col-12" for="plateNumber">{{$t('Vehicles.plateNumber')}} *</label>
            <regular-input
            id="plateNumber"
            :value="trailer.plateNumber"
            @input="trailer.plateNumber = $event"
            type="text" :placeholder="$t('Vehicles.plateNumber')" class="col-12 form-group"/>

            <!-- License Fields -->
            <label class="col-12">{{$t('Vehicles.licenseDocuments')}} *</label>
            <div class="col-12 mb-5">
              <table class="table" v-if="trailer.licenses && trailer.licenses.length>0">
                <tbody>
                  <tr v-for="license, index of trailer.licenses">
                    <td class="col-3">
                      <regular-input
                        id="licenseDocumentName"
                        :value="license.documentName"
                        @input="license.documentName = $event"
                        type="text" :placeholder="$t('Vehicles.documentName')" class="col-12"/>
                    </td>
                    <td class="col-3">
                      <regular-input
                        id="licenseDocumentExpiry"
                        :value="license.documentExpiry"
                        @input="license.documentExpiry = $event"
                        type="text" :placeholder="$t('Vehicles.documentExpiryPattern')" class="col-12"/>
                    </td>
                    <td class="col-5">
                      <custom-vue-dropzone
                        v-if = "!license.documentUrl"
                        :dropzoneMessage="$t('Vehicles.dropzone')"
                        :maxFile="1"
                        :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                        @dropzoneFile="uploadLicenseDocument"
                      />
                      <p v-if="license.documentUrl">{{$t('Vehicles.uploadedFiles')}}: <a :href="license.documentUrl">{{ license.documentUrl.split('_')[1] }}</a></p>
                    </td>
                    <td class="col-1"><button class="btn btn-light" @click="removeLicenseDocument(index)"><strong>&times;</strong></button></td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 text-center">
                <button class="btn btn-light" @click="addLicenseDocument()">{{$t('Users.addDocument')}}</button>
              </div>
            </div>

            <div class="col-12">
              <label for="vin">{{$t('Vehicles.photos')}}</label>
              <custom-vue-dropzone
                :dropzoneMessage="$t('Vehicles.dropzone')"
                :maxFile="10"
                :allowedFileTypes="['.jpeg', '.jpg', '.png']"
                @dropzoneFile="uploadTrailerPhotos"
              />
              <p v-if="trailer.photos && trailer.photos.length>0">{{$t('Vehicles.uploadedFiles')}}: <a class="mr-3" v-for="photo, index of trailer.photos" :href="photo">{{ `Photo${index+1}` }}</a></p>
            </div>

            <label class="col-12 mt-4">{{$t('Vehicles.loadCombinations')}}</label>
            <div class="col-12 mb-3">
              <table class="table" v-if="trailer.loadCombinations && trailer.loadCombinations.length>0">
                <thead>
                  <tr>
                    <th class="col-3 text-center">{{ $t('Vehicles.light') }}</th>
                    <th class="col-3 text-center">{{ $t('Vehicles.medium') }}</th>
                    <th class="col-3 text-center">{{ $t('Vehicles.heavy') }}</th>
                    <th class="col-3 text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="loadCombination, index of trailer.loadCombinations">
                    <td class="col-3">
                      <regular-input
                        id="light"
                        :value="loadCombination.light"
                        @input="loadCombination.light = $event"
                        type="number" :placeholder="$t('Vehicles.light')" class="col-12"/>
                    </td>
                    <td class="col-3">
                      <regular-input
                        id="medium"
                        :value="loadCombination.medium"
                        @input="loadCombination.medium = $event"
                        type="number" :placeholder="$t('Vehicles.medium')" class="col-12"/>
                    </td>
                    <td class="col-3">
                      <regular-input
                        id="heavy"
                        :value="loadCombination.heavy"
                        @input="loadCombination.heavy = $event"
                        type="number" :placeholder="$t('Vehicles.heavy')" class="col-12"/>
                    </td>
                    <td class="col-3"><button class="btn btn-light" @click="removeLoadCombination(index)"><strong>&times;</strong></button></td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 text-center">
                <button class="btn btn-light" @click="addLoadCombination()">{{$t('Vehicles.addLoadCombination')}}</button>
              </div>
            </div>

            <!-- Other Documents Fields -->
            <label class="col-12 mt-3">{{$t('Vehicles.otherDocuments')}}</label>
            <div class="col-12 mb-5">
              <table class="table" v-if="trailer.otherDocuments && trailer.otherDocuments.length>0">
                <tbody>
                  <tr v-for="otherDocument, index of trailer.otherDocuments">
                    <td class="col-3">
                      <regular-input
                        id="otherDocumentName"
                        :value="otherDocument.documentName"
                        @input="otherDocument.documentName = $event"
                        type="text" :placeholder="$t('Vehicles.documentName')" class="col-12"/>
                    </td>
                    <td class="col-3">
                      <regular-input
                        id="otherDocumentExpiry"
                        :value="otherDocument.documentExpiry"
                        @input="otherDocument.documentExpiry = $event"
                        type="text" :placeholder="$t('Vehicles.documentExpiryPattern')" class="col-12"/>
                    </td>
                    <td class="col-5">
                      <custom-vue-dropzone
                        v-if = "!otherDocument.documentUrl"
                        :dropzoneMessage="$t('Vehicles.dropzone')"
                        :maxFile="1"
                        :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                        @dropzoneFile="uploadOtherDocument"
                      />
                      <p v-if="otherDocument.documentUrl">{{$t('Vehicles.uploadedFiles')}}: <a :href="otherDocument.documentUrl">{{ otherDocument.documentUrl.split('_')[1] }}</a></p>
                    </td>
                    <td class="col-1"><button class="btn btn-light" @click="removeOtherDocument(index)"><strong>&times;</strong></button></td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 text-center">
                <button class="btn btn-light" @click="addOtherDocument()">{{$t('Users.addDocument')}}</button>
              </div>
            </div>
          </div>
  
          <div class="col-12">
            <p class="red-text">{{feedbackMessage}}</p>
            <button v-if="add" class="btn btn-kne-orange w-100" @click="addTrailer(trailer.email, trailer.password)">{{$t('Vehicles.addTrailer')}}</button>
            <button v-else class="btn btn-kne-orange w-100" @click="modifyTrailer()">{{$t('Vehicles.modifyTrailer')}}</button>
            <button v-if="modify && isAdmin && !isViewer" class="btn btn-danger w-100 mt-2" @click="deleteTrailer()">{{$t('Vehicles.deleteTrailer')}}</button>
          </div>
        </modal>
      </transition>
  
    </div>
  </template>
  
  <script>
  import Modal from '../module/interface-components/Modal.vue'
  import regularInput from '../module/basic-components/regularInput.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import Search from '../module/special-components/Other-components/Search.vue'
  import {db} from '../../firebase'
  // import _ from 'lodash'
  import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
  import CustomVueDropzone from '../module/special-components/Custom-packages/Custom-VueDropzone.vue'
  
  export default {
    name: 'Vehicles',
  
    components: {
      Modal,
      regularInput,
      regularCheckbox,
      regularTextarea,
      regularSelect,
      Search,
      SidebarToggleButton,
      TableElement,
      LoadingRender,
      hoverToolTip,
      CustomVueDropzone
    },
  
    data () {
      return {
        modalTitle: '',
        add: false,
        modify: false,
        search: false,
        key: '',
        trailer: {
          trailerNumber: '',
          brand: '',
          model: '',
          year: '',
          vin: '',
          plateNumber: '',
          licenses: [],
          photos: [],
          loadCombinations: [],
          otherDocuments: []
        },
        trailers: [],
        fieldsObj: [
          {
            text: this.$t('Vehicles.trailerNumber'),
            type: 'trailerNumber',
            value: ''
          },
          {
            text: this.$t('Vehicles.brand'),
            type: 'brand',
            value: ''
          },
          {
            text: this.$t('Vehicles.model'),
            type: 'model',
            value: ''
          },
          {
            text: this.$t('Vehicles.year'),
            type: 'year',
            value: ''
          },
          {
            text: this.$t('Vehicles.vin'),
            type: 'vin',
            value: ''
          },
          {
            text: this.$t('Vehicles.plateNumber'),
            type: 'plateNumber',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        isLoading: false,
        feedbackMessage: ''
      }
    },
  
    created () {
      this.isLoading = true
      this.$store.state.isSidebarOpen = false
      this.isScreenSmall = window.innerWidth < 800
  
      this.$bindAsArray('trailers', db.ref('database/transporter').child(this.companyUID).child('user').child('trailers'), null, () => {
        this.isLoading = false
      })
    },
  
    methods: {
      updateFilterResults (sortResults) {
        this.filterResults = sortResults
      },

      setModalTitle (title) {
        this.modalTitle = title
      },
  
      openModalAddTrailer () {
        // Method to open the modal
        this.add = true
        this.modalTitle = this.$t('Vehicles.addTrailerTitle')
      },
  
      addTrailer () {
        if (!this.checkTrailerInfo(this.trailer)) return
        db.ref('database/transporter').child(this.companyUID).child('user').child('trailers').push().set(this.trailer).then(() => {
          // ======================== ADD CREATED TRAILER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_TRAILER', 'date': Date.now(), 'TrailerVIN': this.trailer.vin})
          this.clear()
          this.add = !this.add
        }).catch((e) => {
          console.log(e)
        })
      },
  
      checkTrailerInfo (trailer) {
        if (
            !this.validateRequiredField('Vehicles.trailerNumber', trailer.trailerNumber) ||
            (this.add && !this.validateTrailerNumber(trailer.trailerNumber)) ||
            !this.validateRequiredField('Vehicles.brand', trailer.brand) ||
            !this.validateRequiredField('Vehicles.model', trailer.model) ||
            !this.validateRequiredField('Vehicles.year', trailer.year) ||
            !this.validateYear(trailer.year) ||
            !this.validateRequiredField('Vehicles.vin', trailer.vin) ||
            !this.validateRequiredField('Vehicles.plateNumber', trailer.plateNumber) ||
            !this.validateLicense() ||
            !this.validateDocuments('Vehicles.otherDocuments', trailer.otherDocuments) ||
            !this.validateLoadCombinations()
          ) {
            return
        }

        return true
      },
  
      validateExpiry (field, value, required = true) {
        if (!required && !value) {
          this.feedbackMessage = ''
          return true
        }
        // Regular expression for mm/yyyy format
        const regex = /^(0[1-9]|1[0-2])\/\d{4}$/
        if (regex.test(value)) {
          this.feedbackMessage = ''
          return true
        } else {
          this.feedbackMessage = this.$t('Users.modal.invalidExpiryFormat') + this.$t(field)
          return false
        }
      },

      validateYear (year) {
        const yearRegex = /^(?:[1-9]\d{3}|0)$/
        if (yearRegex.test(year)) {
          this.feedbackMessage = ''
          return true
        }
        this.feedbackMessage = this.$t('Vehicles.errors.invalidYear')
        return false
      },
  
      validateRequiredField (field, value) {
        if (!value) {
          this.feedbackMessage = this.$t('Users.modal.requiredField') + this.$t(field)
          return false
        } else {
          this.feedbackMessage = ''
          return true
        }
      },

      validateDocuments (field, documents) {
        let validFlag = true
        documents.forEach((document) => {
          if (!this.validateExpiry(field, document.documentExpiry)) {
            this.feedbackMessage = this.$t('Vehicles.errors.invalidExpiryFormat') + this.$t(field)
            validFlag = false
          } else if (!document.documentName || !document.documentUrl) {
            this.feedbackMessage = this.$t('Vehicles.errors.nonEmptyField') + this.$t(field)
            validFlag = false
          }
        })
        return validFlag
      },

      validateLicense () {
        if (this.trailer.licenses && this.trailer.licenses.length < 1) {
          this.feedbackMessage = this.$t('Vehicles.errors.minimumOneRequired') + this.$t('Vehicles.licenseDocuments')
          return false
        } else {
          if (!this.validateDocuments('Vehicles.licenseDocuments', this.trailer.licenses)) {
            return false
          }
          return true
        }
      },

      validateTrailerNumber (trailerNumber) {
        const trailerNumberList = this.trailers.map((trailer) => {
          return trailer.trailerNumber
        })
        if (trailerNumberList.includes(trailerNumber)) {
          this.feedbackMessage = this.$t('Vehicles.errors.uniqueTrailerNumber')
          return false
        }
        return true
      },

      validateLoadCombinations () {
        const combinations = this.trailer.loadCombinations
        if (combinations.length > 0 &&
          !(combinations[combinations.length - 1].light &&
          combinations[combinations.length - 1].medium &&
          combinations[combinations.length - 1].heavy)) {
            this.feedbackMessage = this.$t('Vehicles.errors.nonEmptyField') + this.$t('Vehicles.loadCombinations')
            return false
        }
        this.feedbackMessage = ''
        return true
      },

      addOtherDocument () {
        const documentData = this.trailer.otherDocuments

        if ((documentData.length > 0 &&
        documentData[documentData.length - 1].documentName &&
        documentData[documentData.length - 1].documentExpiry &&
        documentData[documentData.length - 1].documentUrl) ||
        documentData.length === 0) {
          this.trailer.otherDocuments.push(
            {
              documentName: '',
              documentExpiry: '',
              documentUrl: ''
            }
          )
        }
      },

      removeOtherDocument (id) {
        this.trailer.otherDocuments.splice(id, 1)
      },

      uploadOtherDocument (file) {
        if (file) {
          this.trailer.otherDocuments[this.trailer.otherDocuments.length - 1].documentUrl = file
        }
      },

      addLoadCombination () {
        const documentData = this.trailer.loadCombinations

        if ((documentData.length > 0 &&
        documentData[documentData.length - 1].light &&
        documentData[documentData.length - 1].medium &&
        documentData[documentData.length - 1].heavy) ||
        documentData.length === 0) {
          this.trailer.loadCombinations.push(
            {
              light: null,
              meidum: null,
              heavy: null
            }
          )
        }
      },

      removeLoadCombination (id) {
        this.trailer.loadCombinations.splice(id, 1)
      },

      addLicenseDocument () {
        const documentData = this.trailer.licenses

        if ((documentData.length > 0 &&
        documentData[documentData.length - 1].documentName &&
        documentData[documentData.length - 1].documentExpiry &&
        documentData[documentData.length - 1].documentUrl) ||
        documentData.length === 0) {
          this.trailer.licenses.push(
            {
              documentName: '',
              documentExpiry: '',
              documentUrl: ''
            }
          )
        }
      },

      removeLicenseDocument (id) {
        this.trailer.licenses.splice(id, 1)
      },

      uploadLicenseDocument (file) {
        if (file) {
          this.trailer.licenses[this.trailer.licenses.length - 1].documentUrl = file
        }
      },

      uploadTrailerPhotos (file) {
        if (file) {
          this.trailer.photos.push(file)
        } else {
          this.trailer.photos = []
        }
      },
  
      modifyTrailer: function () {
        if (!this.checkTrailerInfo(this.trailer)) return
        db.ref('database/transporter').child(this.companyUID).child('user').child('trailers').child(this.key).update(this.trailer)
        // ======================== ADD MODIFY USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_TRAILER', 'modifiedTrailerUID': this.key, 'date': Date.now(), 'modifiedVIN': this.trailer.vin})
        // ======================== ADD MODIFY USER LOG =======================
        this.modify = !this.modify
        this.clear()
      },
  
      deleteTrailer: function () {
        db.ref('database/transporter').child(this.companyUID).child('user').child('trailers').child(this.key).remove()
        // ======================== ADD DELETED USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_TRAILER', 'deletedTrailerUID': this.key, 'date': Date.now(), 'deletedVIN': this.trailer.vin})
        // ======================== ADD DELETED USER LOG =======================
        this.modify = !this.modify
        this.clear()
      },
  
      modifying: function (trailer) {
        this.modify = true
        for (var attr in this.trailer) {
          if (!(trailer[attr] === undefined || trailer[attr] === null || typeof trailer[attr] !== typeof this.trailer[attr])) {
            this.trailer[attr] = trailer[attr]
          }
        }
  
        this.key = trailer['.key']
      },
  
      clear: function () {
        for (var attr in this.trailer) {
          if (typeof this.trailer[attr] === 'string') {
            this.trailer[attr] = ''
          } else if (Array.isArray(this.trailer[attr])) {
            this.trailer[attr] = []
          }
        }
        this.feedbackMessage = ''

        this.$bindAsArray('trailers', db.ref('database/transporter').child(this.companyUID).child('user').child('trailers'), null, () => {
          this.isLoading = false
        })
      },
  
      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },
  
    computed: {
      uid () {
        return this.$store.state.user.uid
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      isViewer () {
        return this.$store.state.authorization.role === 'Viewer'
      }
    },

    mounted () {
      this.onResize()
      this.$parent.$on('open-add-trailer-modal', this.openModalAddTrailer)
      window.addEventListener('resize', this.onResize, { passive: true })
    },
    beforeDestroy () {
      this.$parent.$off('open-add-trailer-modal', this.openModalAddTrailer)
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  .hourlyCheckBox {
    display: flex;
    align-items: center;
  }
  label {
    font-weight: 600;
  }
  </style>
